module.exports = __webpack_public_path__ + "static/time-aware-policy-new-1979b45bb9a541c3262e68483141f8a2.png";